export const routes = {
  api: {
    management: {
      auth: {
        logIn: 'manage/auth/log-in',
        verify: 'manage/auth/verify',
        social: {
          url: 'manage/auth/social/{driver}',
          verify: 'manage/auth/social/{driver}',
        },
        forgotPassword: 'manage/auth/forgot-password',
        resetPassword: 'manage/auth/reset-password',
        refresh: 'manage/auth/refresh',
        logOut: 'manage/auth/log-out',
        me: 'manage/auth/me',
        authenticatorUrl: 'manage/auth/authenticator-url',
        completeAuthenticator: 'manage/auth/complete-authenticator',
      },
      alerts: {
        index: 'manage/alerts',
        dismiss: 'manage/alerts/dismiss',
      },
      audits: {
        index: 'manage/audits',
        store: 'manage/audits',
        single: 'manage/audits/{id}',
        update: 'manage/audits/{id}',
        history: 'manage/audits/{id}/history',
        send: 'manage/audits/{id}/send',
        complete: 'manage/audits/{id}/complete',
        summary: 'manage/audits/{id}/summary',
        delete: 'manage/audits/{id}',
        procedures: {
          index: 'manage/audits/{auditId}/procedures',
          update: 'manage/audits/{auditId}/procedures/{id}',
        },
      },
      auditEntries: {
        index: 'manage/audit-entries',
      },
      auditTypes: {
        index: 'manage/audit-types',
        store: 'manage/audit-types',
        single: 'manage/audit-types/{id}',
        update: 'manage/audit-types/{id}',
        delete: 'manage/audit-types/{id}',
      },
      boms: {
        newVersion: 'manage/boms/{id}',
        publish: 'manage/boms/{id}/publish',
        discard: 'manage/boms/{id}',
      },
      categories: {
        index: 'manage/categories',
        store: 'manage/categories',
        single: 'manage/categories/{id}',
        update: 'manage/categories/{id}',
        delete: 'manage/categories/{id}',
      },
      clocking: {
        engineers: {
          index: 'manage/clocking/engineers',
          store: 'manage/clocking/engineers',
          update: 'manage/clocking/engineers/{id}',
          delete: 'manage/clocking/engineers/{id}',
        },
      },
      configuration: {
        index: 'manage/configuration',
        update: 'manage/configuration',
      },
      contacts: {
        customers: {
          index: 'manage/contacts/customers',
          store: 'manage/contacts/customers',
          single: 'manage/contacts/customers/{id}',
          update: 'manage/contacts/customers/{id}',
          history: 'manage/contacts/customers/{id}/history',
          delete: 'manage/contacts/customers/{id}',
        },
        endUsers: {
          index: 'manage/contacts/end-users',
          store: 'manage/contacts/end-users',
          single: 'manage/contacts/end-users/{id}',
          update: 'manage/contacts/end-users/{id}',
          history: 'manage/contacts/end-users/{id}/history',
          delete: 'manage/contacts/end-users/{id}',
        },
        people: {
          index: 'manage/contacts/people',
          store: 'manage/contacts/people',
          single: 'manage/contacts/people/{id}',
          update: 'manage/contacts/people/{id}',
          history: 'manage/contacts/people/{id}/history',
          delete: 'manage/contacts/people/{id}',
        },
        locations: {
          index: 'manage/contacts/locations',
          store: 'manage/contacts/locations',
          single: 'manage/contacts/locations/{id}',
          update: 'manage/contacts/locations/{id}',
          history: 'manage/contacts/locations/{id}/history',
          delete: 'manage/contacts/locations/{id}',
        },
        notes: {
          index: 'manage/contacts/notes',
          export: 'manage/contacts/notes/export',
          store: 'manage/contacts/notes',
          single: 'manage/contacts/notes/{id}',
          update: 'manage/contacts/notes/{id}',
          history: 'manage/contacts/notes/{id}/history',
        },
      },
      displays: {
        index: 'manage/displays',
        create: 'manage/displays',
        single: 'manage/displays/{id}',
        update: 'manage/displays/{id}',
        changeBackground: 'manage/displays/{id}/background',
        delete: 'manage/displays/{id}',
      },
      engineers: {
        index: 'manage/engineers',
        store: 'manage/engineers',
        hoursExport: 'manage/engineers/hours',
        single: 'manage/engineers/{id}',
        update: 'manage/engineers/{id}',
        delete: 'manage/engineers/{id}',
        history: 'manage/engineers/{id}/history',
        hours: 'manage/engineers/{id}/hours',
        allocations: 'manage/engineers/{id}/allocations',
        basicWeek: {
          update: 'manage/engineers/{id}/basic-week',
          delete: 'manage/engineers/{engineerId}/basic-week/{id}',
        },
        workingDays: 'manage/engineers/{id}/working-days',
        signatures: {
          index: 'manage/engineers/{engineerId}/signatures',
          store: 'manage/engineers/{engineerId}/signatures',
          single: 'manage/engineers/{engineerId}/signatures/{id}',
          download: 'manage/engineers/{engineerId}/signatures/{id}/download',
          delete: 'manage/engineers/{engineerId}/signatures/{id}',
        },
      },
      files: {
        index: 'manage/files',
        single: 'manage/files/file/{id?}',
        branch: 'manage/files/branch/{id?}',
        branches: 'manage/files/branches',
        format: 'manage/files/file/{id}/format',
        store: 'manage/files',
        move: 'manage/files/move',
        download: 'manage/files/download',
        delete: 'manage/files',
        update: 'manage/files/file/{id}',
        rotate: 'manage/files/file/{id}/rotate',
        analyse: 'manage/files/file/{id}/analyse',
      },
      fixedCosts: {
        index: 'manage/fixed-costs',
        create: 'manage/fixed-costs',
      },
      holidays: {
        index: 'manage/holidays',
        single: 'manage/holidays/{id}',
      },
      includes: 'manage/includes',
      hardwareRegistrations: {
        index: 'manage/hardware-registrations',
        registered: 'manage/hardware-registrations/{id}',
      },
      informationRequests: {
        index: 'manage/information-requests',
        create: 'manage/information-requests',
        single: 'manage/information-requests/{id}',
        send: 'manage/information-requests/{id}/send',
        recipients: {
          update: 'manage/information-requests/{requestId}/recipients/{id}',
        },
      },
      jobs: {
        index: 'manage/jobs',
        single: 'manage/jobs/{id}',
        swapVehicles: 'manage/jobs/swap-vehicles',
        create: 'manage/jobs',
        update: 'manage/jobs/{id}',
        duplicate: 'manage/jobs/{id}',
        duplicateStock: 'manage/jobs/{id}/duplicate-stock',
        swapStock: 'manage/jobs/{id}/swap-stock',
        delete: 'manage/jobs/{id}',
        restore: 'manage/jobs/{id}/restore',
        history: 'manage/jobs/{id}/history',
        downloadImages: 'manage/jobs/{id}/download-images',
        summary: 'manage/jobs/{id}/summary',
        workReport: 'manage/jobs/{id}/work-report',
        jobCard: 'manage/jobs/{id}/job-card',
        sendToStores: 'manage/jobs/{id}/send-to-stores',
        toRecall: 'manage/jobs/{id}/to-recall',
        cancelRecall: 'manage/jobs/{id}/cancel-recall',
        recalled: 'manage/jobs/{id}/recalled',
        readyToInvoice: 'manage/jobs/{id}/ready-to-invoice',
        notReadyToInvoice: 'manage/jobs/{id}/not-ready-to-invoice',
        invoiced: 'manage/jobs/{id}/invoiced',
        freeOfCharge: 'manage/jobs/{id}/free-of-charge',
        noInvoiceRequired: 'manage/jobs/{id}/no-invoice-required',
        notInvoiced: 'manage/jobs/{id}/not-invoiced',
        documents: {
          index: 'manage/jobs/{jobId}/documents',
          create: 'manage/jobs/{jobId}/documents',
          update: 'manage/jobs/{jobId}/documents/{id}',
          single: 'manage/jobs/{jobId}/documents/{id}',
          delete: 'manage/jobs/{jobId}/documents/{id}',
        },
        images: {
          index: 'manage/jobs/{jobId}/images',
          download: 'manage/jobs/{jobId}/images/{id}',
        },
        signatures: {
          index: 'manage/jobs/{jobId}/signatures',
          create: 'manage/jobs/{jobId}/signatures',
          single: 'manage/jobs/{jobId}/signatures/{id}',
          delete: 'manage/jobs/{jobId}/signatures/{id}',
        },
        stock: {
          index: 'manage/jobs/{jobId}/stock',
          single: 'manage/jobs/{jobId}/stock/{id}',
          store: 'manage/jobs/{jobId}/stock',
          addFromQuote: 'manage/jobs/{jobId}/stock/add-from-quote',
          update: 'manage/jobs/{jobId}/stock/{id}',
          allocate: 'manage/jobs/{jobId}/stock/{id}/allocate',
          transfer: 'manage/jobs/{jobId}/stock/{id}/transfer',
          checkOut: 'manage/jobs/{jobId}/stock/{id}/check-out',
          delete: 'manage/jobs/{jobId}/stock/{id}',
          products: {
            store: 'manage/jobs/{jobId}/stock/{groupId}/products',
            update: 'manage/jobs/{jobId}/stock/{groupId}/products/{id}',
            allocate:
              'manage/jobs/{jobId}/stock/{groupId}/products/{id}/allocate',
            transfer:
              'manage/jobs/{jobId}/stock/{groupId}/products/{id}/transfer',
            checkOut:
              'manage/jobs/{jobId}/stock/{groupId}/products/{id}/check-out',
            checkIn:
              'manage/jobs/{jobId}/stock/{groupId}/products/{id}/check-in',
            delete: 'manage/jobs/{jobId}/stock/{groupId}/products/{id}',
            items: {
              allocate:
                'manage/jobs/{jobId}/stock/{groupId}/products/{productId}/items/{id}/allocate',
              checkIn:
                'manage/jobs/{jobId}/stock/{groupId}/products/{productId}/items/{id}/check-in',
              transfer:
                'manage/jobs/{jobId}/stock/{groupId}/products/{productId}/items/{id}/transfer',
            },
          },
        },
      },
      jobAllocations: {
        index: 'manage/job-allocations',
        batchUpdate: 'manage/job-allocations',
        single: 'manage/job-allocations/{id}',
        store: 'manage/job-allocations',
        sendDigest: 'manage/job-allocations/send-digest',
        update: 'manage/job-allocations/{id}',
        duplicate: 'manage/job-allocations/{id}',
        delete: 'manage/job-allocations/{id}',
        restore: 'manage/job-allocations/{id}/restore',
        history: 'manage/job-allocations/{id}/history',
        images: {
          index: 'manage/job-allocations/{allocationId}/images',
          store: 'manage/job-allocations/{allocationId}/images',
          download: 'manage/job-allocations/{allocationId}/images/{id}',
          delete: 'manage/job-allocations/{allocationId}/images/{id}',
        },
        updates: {
          store: 'manage/job-allocations/{allocationId}/updates',
          update: 'manage/job-allocations/{allocationId}/updates/{id}',
        },
      },
      marketingOpportunities: {
        create: 'manage/marketing-opportunities',
        index: 'manage/marketing-opportunities',
        single: 'manage/marketing-opportunities/{id}',
        update: 'manage/marketing-opportunities/{id}',
        delete: 'manage/marketing-opportunities/{id}',
      },
      mobileDevices: {
        index: 'manage/mobile-devices',
        single: 'manage/mobile-devices/{id}',
      },
      notes: {
        index: 'manage/notes',
        store: 'manage/notes',
        single: 'manage/notes/{id}',
        update: 'manage/notes/{id}',
        delete: 'manage/notes/{id}',
        history: 'manage/notes/{id}/history',
      },
      noticeCategories: {
        index: 'manage/notice-categories',
        store: 'manage/notice-categories',
        single: 'manage/notice-categories/{id}',
        update: 'manage/notice-categories/{id}',
        delete: 'manage/notice-categories/{id}',
      },
      notices: {
        index: 'manage/notices',
        store: 'manage/notices',
        single: 'manage/notices/{id}',
        update: 'manage/notices/{id}',
        send: 'manage/notices/{id}/send',
        history: 'manage/notices/{id}/history',
        delete: 'manage/notices/{id}',
      },
      notifications: {
        index: 'manage/notifications',
        create: 'manage/notifications',
        dismiss: 'manage/notifications/dismiss',
      },
      openAuth: {
        index: 'manage/open-auth',
        create: 'manage/open-auth',
        complete: 'manage/open-auth/complete',
        start: 'manage/open-auth/{id}/start',
        reset: 'manage/open-auth/{id}/reset',
      },
      orderPackages: {
        index: 'manage/order-packages',
        store: 'manage/order-packages',
        replace: 'manage/order-packages/replace',
        single: 'manage/order-packages/{id}',
        update: 'manage/order-packages/{id}',
        duplicate: 'manage/order-packages/{id}',
        delete: 'manage/order-packages/{id}',
      },
      overtime: {
        index: 'manage/overtime',
        toggle: 'manage/overtime',
      },
      postWorkImages: {
        index: 'manage/post-work-images',
        create: 'manage/post-work-images',
        approve: 'manage/post-work-images/approve',
        reject: 'manage/post-work-images/reject',
        download: 'manage/post-work-images/{id}',
        delete: 'manage/post-work-images/{id}',
      },
      products: {
        index: 'manage/products',
        store: 'manage/products',
        single: 'manage/products/{id}',
        update: 'manage/products/{id}',
        delete: 'manage/products/{id}',
        availability: 'manage/products/{id}/availability',
        history: 'manage/products/{id}/history',
      },
      purchaseOrders: {
        index: 'manage/purchase-orders',
        store: 'manage/purchase-orders',
        createForJob: 'manage/purchase-orders/for-job',
        single: 'manage/purchase-orders/{id}',
        update: 'manage/purchase-orders/{id}',
        duplicate: 'manage/purchase-orders/{id}',
        void: 'manage/purchase-orders/{id}/void',
        checkIn: 'manage/purchase-orders/{id}/check-in',
        reverse: 'manage/purchase-orders/{id}/reverse',
        summary: 'manage/purchase-orders/{id}/summary',
        delete: 'manage/purchase-orders/{id}',
        groups: {
          index: 'manage/purchase-orders/{orderId}/groups',
          store: 'manage/purchase-orders/{orderId}/groups',
          update: 'manage/purchase-orders/{orderId}/groups/{id}',
          checkIn: 'manage/purchase-orders/{orderId}/groups/{id}/check-in',
          reverse: 'manage/purchase-orders/{orderId}/groups/{id}/reverse',
          delete: 'manage/purchase-orders/{orderId}/groups/{id}',
          products: {
            store: 'manage/purchase-orders/{orderId}/groups/{groupId}/products',
            update:
              'manage/purchase-orders/{orderId}/groups/{groupId}/products/{id}',
            checkIn:
              'manage/purchase-orders/{orderId}/groups/{groupId}/products/{id}/check-in',
            reverse:
              'manage/purchase-orders/{orderId}/groups/{groupId}/products/{id}/reverse',
            delete:
              'manage/purchase-orders/{orderId}/groups/{groupId}/products/{id}',
          },
        },
        notes: {
          index: 'manage/purchase-orders/{orderId}/notes',
          store: 'manage/purchase-orders/{orderId}/notes',
        },
      },
      quotes: {
        index: 'manage/quotes',
        create: 'manage/quotes',
        single: 'manage/quotes/{id}',
        update: 'manage/quotes/{id}',
        duplicate: 'manage/quotes/{id}',
        billOfMaterials: 'manage/quotes/{id}/bill-of-materials',
        delete: 'manage/quotes/{id}',
        groups: {
          create: 'manage/quotes/{quoteId}/groups',
          update: 'manage/quotes/{quoteId}/groups/{id}',
          delete: 'manage/quotes/{quoteId}/groups/{id}',
          products: {
            create: 'manage/quotes/{quoteId}/groups/{groupId}/products',
            update: 'manage/quotes/{quoteId}/groups/{groupId}/products/{id}',
            delete: 'manage/quotes/{quoteId}/groups/{groupId}/products/{id}',
          },
        },
      },
      reporting: {
        availabilitySummary: 'manage/reporting/availability-summary',
        materialsPurchased: 'manage/reporting/materials-purchased',
        workValue: 'manage/reporting/work-value',
        salesQuoteItems: 'manage/reporting/sales-quote-items',
        stockReport: 'manage/reporting/stock-report',
      },
      salesPurchaseOrders: {
        index: 'manage/sales-purchase-orders',
        store: 'manage/sales-purchase-orders',
        single: 'manage/sales-purchase-orders/{id}',
        update: 'manage/sales-purchase-orders/{id}',
        duplicate: 'manage/sales-purchase-orders/{id}',
        history: 'manage/sales-purchase-orders/{id}/history',
        book: 'manage/sales-purchase-orders/{id}/book',
        delete: 'manage/sales-purchase-orders/{id}',
        documents: {
          index: 'manage/sales-purchase-orders/{orderId}/documents',
          store: 'manage/sales-purchase-orders/{orderId}/documents',
          update: 'manage/sales-purchase-orders/{orderId}/documents/{id}',
          single: 'manage/sales-purchase-orders/{orderId}/documents/{id}',
          download:
            'manage/sales-purchase-orders/{orderId}/documents/{id}/download',
          delete: 'manage/sales-purchase-orders/{orderId}/documents/{id}',
        },
      },
      salesQuotes: {
        index: 'manage/sales-quotes',
        create: 'manage/sales-quotes',
        single: 'manage/sales-quotes/{id}',
        amend: 'manage/sales-quotes/{id}/amend',
        delete: 'manage/sales-quotes/{id}',
        files: {
          index: 'manage/sales-quotes/{quoteId}/files',
          create: 'manage/sales-quotes/{quoteId}/files',
          single: 'manage/sales-quotes/{quoteId}/files/{id}',
          update: 'manage/sales-quotes/{quoteId}/files/{id}',
          download: 'manage/sales-quotes/{quoteId}/files/{id}/download',
          delete: 'manage/sales-quotes/{quoteId}/files/{id}',
        },
        notes: {
          index: 'manage/sales-quotes/{quoteId}/notes',
          create: 'manage/sales-quotes/{quoteId}/notes',
        },
        revisions: {
          create: 'manage/sales-quotes/{quoteId}/revisions',
          update: 'manage/sales-quotes/{quoteId}/revisions/{id}',
          amend: 'manage/sales-quotes/{quoteId}/revisions/{id}/amend',
          toggleExempt:
            'manage/sales-quotes/{quoteId}/revisions/{id}/toggle-exempt',
          publish: 'manage/sales-quotes/{quoteId}/revisions/{id}/publish',
          accept: 'manage/sales-quotes/{quoteId}/revisions/{id}/accept',
          reject: 'manage/sales-quotes/{quoteId}/revisions/{id}/reject',
          void: 'manage/sales-quotes/{quoteId}/revisions/{id}/void',
          reset: 'manage/sales-quotes/{quoteId}/revisions/{id}/reset',
          copy: 'manage/sales-quotes/{quoteId}/revisions/{id}/copy',
          send: 'manage/sales-quotes/{quoteId}/revisions/{id}/send',
          summary: 'manage/sales-quotes/{quoteId}/revisions/{id}/summary',
          items: {
            create:
              'manage/sales-quotes/{quoteId}/revisions/{revisionId}/items',
            update:
              'manage/sales-quotes/{quoteId}/revisions/{revisionId}/items/{id}',
            delete:
              'manage/sales-quotes/{quoteId}/revisions/{revisionId}/items/{id}',
          },
          vehicles: {
            update:
              'manage/sales-quotes/{quoteId}/revisions/{revisionId}/vehicles',
            order:
              'manage/sales-quotes/{quoteId}/revisions/{revisionId}/vehicles/{id}/order',
          },
        },
      },
      search: {
        index: 'manage/search',
      },
      signIns: {
        index: 'manage/sign-ins',
        export: 'manage/sign-ins/export',
      },
      sites: {
        index: 'manage/sites',
        store: 'manage/sites',
        single: 'manage/sites/{id}',
        update: 'manage/sites/{id}',
        delete: 'manage/sites/{id}',
        history: 'manage/sites/{id}/history',
      },
      smukCodes: {
        index: 'manage/smuk-codes',
        create: 'manage/smuk-codes',
        replace: 'manage/smuk-codes/replace',
        single: 'manage/smuk-codes/{id}',
        update: 'manage/smuk-codes/{id}',
        duplicate: 'manage/smuk-codes/{id}',
        product: 'manage/smuk-codes/{id}/product',
        merge: 'manage/smuk-codes/{id}/merge',
        billOfMaterials: 'manage/smuk-codes/{id}/bill-of-materials',
        delete: 'manage/smuk-codes/{id}',
        kits: {
          index: 'manage/smuk-codes/{codeId}/kits',
          create: 'manage/smuk-codes/{codeId}/kits',
          update: 'manage/smuk-codes/{codeId}/kits/{id}',
          delete: 'manage/smuk-codes/{codeId}/kits/{id}',
          copy: 'manage/smuk-codes/{codeId}/kits/copy',
        },
      },
      smukCodeCategories: {
        index: 'manage/smuk-code-categories',
        create: 'manage/smuk-code-categories',
        update: 'manage/smuk-code-categories/{id}',
        delete: 'manage/smuk-code-categories/{id}',
      },
      smukCodeTypes: {
        index: 'manage/smuk-code-types',
        create: 'manage/smuk-code-types',
        update: 'manage/smuk-code-types/{id}',
        delete: 'manage/smuk-code-types/{id}',
      },
      stockItems: {
        index: 'manage/stock-items',
        store: 'manage/stock-items',
        checkIn: 'manage/stock-items/check-in',
        single: 'manage/stock-items/{id}',
        update: 'manage/stock-items/{id}',
        delete: 'manage/stock-items/{id}',
        history: 'manage/stock-items/{id}/history',
      },
      stockItemLogs: {
        index: 'manage/stock-item-logs',
      },
      stockLocations: {
        index: 'manage/stock-locations',
        store: 'manage/stock-locations',
        single: 'manage/stock-locations/{id}',
        update: 'manage/stock-locations/{id}',
        delete: 'manage/stock-locations/{id}',
        restore: 'manage/stock-locations/{id}/restore',
        history: 'manage/stock-locations/{id}/history',
        tallies: 'manage/stock-locations/{id}/tallies',
        amendLevels: 'manage/stock-locations/{id}/amend-levels',
      },
      users: {
        index: 'manage/users',
        create: 'manage/users',
        permissions: 'manage/users/permissions',
        single: 'manage/users/{id}',
        update: 'manage/users/{id}',
        permission: 'manage/users/{id}/permissions',
        changePassword: 'manage/users/{id}/password',
        sendPasswordReset: 'manage/users/{id}/send-password-reset',
        resetTwoFactorAuthentication:
          'manage/users/{id}/reset-two-factor-authentication',
      },
      utilities: {
        importChargingSessions: 'manage/utilities/charging-sessions',
      },
      vehicles: {
        index: 'manage/vehicles',
        makes: 'manage/vehicles/makes',
        store: 'manage/vehicles',
        single: 'manage/vehicles/{id}',
        update: 'manage/vehicles/{id}',
        history: 'manage/vehicles/{id}/history',
        delete: 'manage/vehicles/{id}',
      },
      vehicleVariants: {
        index: 'manage/vehicle-variants',
        store: 'manage/vehicle-variants',
        single: 'manage/vehicle-variants/{id}',
        update: 'manage/vehicle-variants/{id}',
        history: 'manage/vehicle-variants/{id}/history',
        delete: 'manage/vehicle-variants/{id}',
      },
    },
    site: {
      v1: {
        sites: 'site/v1/sites',
        attendees: 'site/v1/attendees',
        verify: 'site/v1/verify',
        attendance: {
          report: 'site/v1/attendance',
        },
        engineers: {
          index: 'site/v1/engineers',
          authenticate: 'site/v1/engineers',
          clockIn: 'site/v1/engineers/clock-in',
          clockOut: 'site/v1/engineers/clock-out',
        },
        users: {
          index: 'site/v1/users',
          authenticate: 'site/v1/users',
          clockIn: 'site/v1/users/clock-in',
          clockOut: 'site/v1/users/clock-out',
        },
        visitors: {
          index: 'site/v1/visitors',
          clockIn: 'site/v1/visitors/clock-in',
          clockOut: 'site/v1/visitors/clock-out',
        },
      },
    },
  },
}
